import { createClient } from "@sanity/client";

export const clientCMSbanner = createClient({
  projectId: "wssh46sv",
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: "2024-01-01",
  useCdn: false,
});
